import { createContext, ReactNode, useState } from 'react';

interface FormikContextType {
  formikContexts: any;
  addFormikContext: (categoryId: number, context: any) => void;
}

interface FormikContextProps {
  children: ReactNode;
}

export const FormikContext = createContext<FormikContextType>(null);

const FormikContextProvider = ({ children }: FormikContextProps) => {
  const [formikContexts, setformikContexts] = useState<any>({});

  const addFormikContext = (categoryId, context) => {
    setformikContexts({
      ...formikContexts,
      [categoryId]: context,
    });
  };

  return (
    <FormikContext.Provider value={{
      formikContexts,
      addFormikContext,
    }}
    >
      {children}
    </FormikContext.Provider>
  );
};

export default FormikContextProvider;
